export const userOnboardingStateFragment = gql`
  fragment UserOnboardingStateFragment on UserOnboardingState {
    id
    userId
    scopeKey
    key
    dismissedAt
    completedAt
    lastSeenAt
    payload
    createdAt
    updatedAt
  }
`;

export const USER_ONBOARDING_STATES_QUERY = gql`
  query UserOnboardingStatesQuery($scopeKeys: [String!]!) {
    userOnboardingStates(scopeKeys: $scopeKeys) {
      ...UserOnboardingStateFragment
    }
  }

  ${userOnboardingStateFragment}
`;

export const UPSERT_USER_ONBOARDING_STATE_MUTATION = gql`
  mutation UpsertUserOnboardingStateMutation(
    $input: UpsertUserOnboardingStateInput!
  ) {
    upsertUserOnboardingState(input: $input) {
      ...UserOnboardingStateFragment
    }
  }

  ${userOnboardingStateFragment}
`;
